export const MEDIA_ACCEPT_IMAGE =
  "image/jpeg,image/png,image/tiff,image/gif,image/webp,image/bmp,image/svg+xml";

export const MEDIA_ACCEPT_DOCUMENT = "application/pdf";

const w = window as any;

export const BACKEND_URL =
  w.SurveyConfig?.BACKEND_URL ??
  process.env.REACT_APP_BACKEND_URL ??
  "http://localhost/a_a3/";
export const PUBLIC_URL = w.SurveyConfig?.PUBLIC_URL ?? process.env.PUBLIC_URL;

if (!w.AdaptiveUi) w.AdaptiveUi = {};

if (!w.AdaptiveUi.THEME)
  w.AdaptiveUi.THEME = w.SurveyConfig?.THEME ?? "adaptive3";

export const SESSION_TOKEN_KEY = "admin::gm_session_id";

export const SUPPORTED_LANGUAGES = [
  { value: "no", label: "Norsk" },
  { value: "en", label: "English" },
];
